import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar'; 
import Footer from '../components/Footer'; 
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Instagram, Linkedin, Twitter, MessageCircle, Facebook, Send } from 'lucide-react';
import { toast } from 'sonner';
import { useLanguage } from '../context/LanguageContext'; // YENİ: Dil Desteği İçe Aktarıldı

// --- API BAĞLANTI AYARI (Otomatik) ---
const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// --- LİNK DÜZELTİCİ FONKSİYON ---
const getExternalLink = (url) => {
  if (!url) return "#";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `https://${url}`;
};

const ContactPage = () => {
  const { language } = useLanguage(); // YENİ: Dil değişkenini çekiyoruz
  const [settings, setSettings] = useState({});
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });

  // İletişim bilgilerini Backend'den çek
  useEffect(() => {
    fetch(`${API}/settings`)
      .then(res => res.json())
      .then(data => setSettings(data || {}))
      .catch(err => console.error("Ayarlar yüklenemedi", err));
      
    window.scrollTo(0, 0);
  }, []);

  // Form Gönderme İşlemi
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (res.ok) {
        // YENİ: Mesajlar dile göre değişiyor
        toast.success(language === 'tr' ? "Mesajınız başarıyla gönderildi!" : "Message sent successfully!");
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        toast.error(language === 'tr' ? "Bir hata oluştu." : "An error occurred.");
      }
    } catch (error) {
      toast.error(language === 'tr' ? "Sunucu hatası." : "Server error.");
    }
  };

  // YENİ: Çeviri Metinleri
  const t = {
    title: language === 'tr' ? 'Bize Ulaşın' : 'Contact Us',
    desc: language === 'tr' ? 'Projeleriniz için bir teklif alın veya sorularınızı bize iletin.' : 'Get a quote for your projects or send us your questions.',
    form_title: language === 'tr' ? 'Mesaj Gönderin' : 'Send a Message',
    ph_name: language === 'tr' ? 'Adınız Soyadınız' : 'Full Name',
    ph_email: language === 'tr' ? 'E-posta Adresiniz' : 'Email Address',
    ph_subject: language === 'tr' ? 'Konu' : 'Subject',
    ph_message: language === 'tr' ? 'Mesajınız...' : 'Your Message...',
    btn_send: language === 'tr' ? 'MESAJI GÖNDER' : 'SEND MESSAGE'
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Navbar /> {/* Navigasyon */}

      <div className="flex-grow pt-32 px-6 pb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          
          {/* SOL TARA: LOGO ve İLETİŞİM BİLGİLERİ */}
          <motion.div initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }}>
            
            {/* Logo (Site Başlığı) */}
            <h1 className="font-emblema text-6xl text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 mb-6">
               {settings.about_title || "MERTT"}
            </h1>

            <h2 className="text-3xl font-bold mb-6 text-white">
              {t.title}
            </h2>
            <p className="text-gray-400 mb-8 text-lg">
              {t.desc}
            </p>
            
            <div className="space-y-6">
              {settings.phone && (
                <div className="flex items-center gap-4 text-lg p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-blue-500/50 transition">
                  <div className="p-3 bg-blue-600/20 rounded-full text-blue-400"><Phone size={24} /></div>
                  <span>{settings.phone}</span>
                </div>
              )}
              {settings.email && (
                <div className="flex items-center gap-4 text-lg p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-purple-500/50 transition">
                  <div className="p-3 bg-purple-600/20 rounded-full text-purple-400"><Mail size={24} /></div>
                  <span>{settings.email}</span>
                </div>
              )}
              {settings.address && (
                <div className="flex items-center gap-4 text-lg p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-green-500/50 transition">
                  <div className="p-3 bg-green-600/20 rounded-full text-green-400"><MapPin size={24} /></div>
                  <span>{settings.address}</span>
                </div>
              )}
            </div>

            {/* Sosyal Medya İkonları */}
            <div className="flex gap-4 mt-10">
              {settings.instagram && (
                  <a href={getExternalLink(settings.instagram)} target="_blank" rel="noreferrer" className="p-3 bg-gray-800 rounded-full text-gray-400 hover:text-white hover:bg-pink-600 transition transform hover:scale-110">
                      <Instagram size={24} />
                  </a>
              )}
              {settings.linkedin && (
                  <a href={getExternalLink(settings.linkedin)} target="_blank" rel="noreferrer" className="p-3 bg-gray-800 rounded-full text-gray-400 hover:text-white hover:bg-blue-700 transition transform hover:scale-110">
                      <Linkedin size={24} />
                  </a>
              )}
              {settings.twitter && (
                  <a href={getExternalLink(settings.twitter)} target="_blank" rel="noreferrer" className="p-3 bg-gray-800 rounded-full text-gray-400 hover:text-white hover:bg-sky-500 transition transform hover:scale-110">
                      <Twitter size={24} />
                  </a>
              )}
              {settings.facebook && (
                  <a href={getExternalLink(settings.facebook)} target="_blank" rel="noreferrer" className="p-3 bg-gray-800 rounded-full text-gray-400 hover:text-white hover:bg-blue-800 transition transform hover:scale-110">
                    <Facebook size={24} />
                  </a>
              )}
              {settings.whatsapp && (
                  <a href={`https://wa.me/${settings.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" className="p-3 bg-gray-800 rounded-full text-gray-400 hover:text-white hover:bg-green-500 transition transform hover:scale-110">
                      <MessageCircle size={24} />
                  </a>
              )}
            </div>
          </motion.div>

          {/* SAĞ TARAF: İLETİŞİM FORMU */}
          <motion.div initial={{ x: 50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: 0.2 }}>
            <form onSubmit={handleSubmit} className="bg-gray-900 p-8 rounded-2xl border border-gray-800 space-y-5 shadow-2xl">
              <h3 className="text-2xl font-bold mb-4">{t.form_title}</h3>
              
              <input 
                type="text" placeholder={t.ph_name} required 
                className="w-full bg-black border border-gray-700 p-4 rounded-lg text-white focus:border-blue-500 outline-none transition"
                value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})}
              />
              <input 
                type="email" placeholder={t.ph_email} required 
                className="w-full bg-black border border-gray-700 p-4 rounded-lg text-white focus:border-blue-500 outline-none transition"
                value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
              <input 
                type="text" placeholder={t.ph_subject} required 
                className="w-full bg-black border border-gray-700 p-4 rounded-lg text-white focus:border-blue-500 outline-none transition"
                value={formData.subject} onChange={(e) => setFormData({...formData, subject: e.target.value})}
              />
              <textarea 
                rows="4" placeholder={t.ph_message} required 
                className="w-full bg-black border border-gray-700 p-4 rounded-lg text-white focus:border-blue-500 outline-none transition"
                value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})}
              ></textarea>
              
              <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-4 rounded-lg transition transform active:scale-95 flex items-center justify-center gap-2">
                <Send size={20} /> {t.btn_send}
              </button>
            </form>
          </motion.div>

        </div>
      </div>

      <Footer /> {/* Footer */}
    </div>
  );
};

export default ContactPage;